import Vue from 'vue'
import { clockState } from '../types'

const state = {
  minute: 0
} as clockState

const getters = {
}

const actions = {
}

const mutations = {
  update (state) {
    const d = new Date()
    Vue.set(state, 'minute', Math.floor(d.getTime() / 60000))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} as const
